import styled from 'styled-components';

import { StyledControlBarButton } from '../editor-bar-button.styles';

export const StyledButton = styled(StyledControlBarButton)`
  &:hover {
    svg circle {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnHover};
    }
    svg path {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.searchIcon
          .colorOnHover};
    }
  }
`;
